import { LOGIN, LOGIN_SUCCESS, LOGIN_ERROR, RESET_LOGIN_STATUS } from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';
import { setToken } from 'services/axios';
import { setDataToLocalStorage } from 'services/local-storage';
import { initialState } from './initialize-state';
import { StorageType } from 'common/enum/index';

const loginReducer = handleActions(
  new Map([
    [
      LOGIN,
      state => {
        return update(state, {
          loadingStatus: {
            loginLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOGIN_SUCCESS,
      (state, action) => {
        setDataToLocalStorage(StorageType.AuthInfo, action.payload);
        setToken(action.payload.token);
        return update(state, {
          loadingStatus: {
            loginLoading: { $set: false },
          },
          data: { $set: action.payload },
        });
      },
    ],
    [
      LOGIN_ERROR,
      (state, action) => {
        setDataToLocalStorage(StorageType.AuthInfo, null);
        return update(state, {
          loadingStatus: {
            loginLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      RESET_LOGIN_STATUS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginLoading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default loginReducer;
